import React,{Component} from 'react'
import { DataGrid } from '@mui/x-data-grid';
import {  GridToolbar,GridActionsCellItem } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { getToken ,getUser} from '../util';
import Card from './report'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControl from '@mui/material/FormControl';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import Button from '@mui/material/Button';
import { DatePicker } from '@atlaskit/datetime-picker';
//import { DataGrid } from '@mui/x-data-grid';
export default class Reports extends Component{
    constructor(){
        super()
        this.state={
          licenseData:[],
          moduleData:[],
          modules:[],
          recordmodel:false,
          curDate:'',
          columns : [
      
            { field: 'id', headerName: 'ID',  width: 150,editable: false },
            { field: 'productkey', headerName: 'PRODUCTKEY', width: 350, editable: false },
            { field: 'newsupportpin', headerName: 'SUPPORT_PIN',  width: 250,editable: false },
            { field: 'date', headerName: 'PINCHANGE_DATE',  width: 150,editable: false },
            
        ],
        rows:[],
        fromDate:'',
        toDate:'',
        fromDate1:'',
        toDate1:'',
        rows1:[],
        columns1: [
      
          { field: 'id', headerName: 'ID',  width: 150,editable: false },
          { field: 'productkey', headerName: 'PRODUCTKEY', width: 350, editable: false },
          { field: 'supportpin', headerName: 'SUPPORT_PIN',  width: 250,editable: false },
          { field: 'date', headerName: 'SURRENDER_DATE',  width: 150,editable: false },
          
      ],
        }
    }
    componentDidMount=()=>{
        this.getLicenseDetails(getUser().registerno,getUser().emailid)
        this.getCurrentDate()
    }
    getCurrentDate=(separator='-')=>{
      let newDate = new Date()
      let date = newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year = newDate.getFullYear();
      let curdate=`${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date<10?`0${date}`:`${date}`}`
      this.setState({fromDate:curdate,toDate:curdate,curDate:curdate,fromDate1:curdate,toDate1:curdate})
  }
    onDisplayModules=(productkey,separator=',')=>{
      this.setState({modules:[],rows:[],rows1:[]})
      let array_data=[]
      for(let data of this.state.moduleData){
        if(data.productKey===productkey){
          for(let mData of data.module){
            let tempData=`${mData.modulename.toUpperCase()}${separator}`
            array_data.push(tempData)
          }
          this.setState({modules:array_data})
        }
      }
    }
    getLicenseDetails=(registerNo,emailId)=>{
      this.setState({rows:[]})
      fetch(`eadmin/v1/set/check_license_details?emailId=${emailId}&registerNo=${registerNo}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          "x-access-token":getToken(),
        },
        }).then((response) => response.json())
        .then((responseJson) => {
        if(responseJson.status ){
         // alert(JSON.stringify(responseJson))
          this.setState({licenseData:responseJson.licenseData,moduleData:responseJson.moduleData})
        }else if(!responseJson.status){
          this.setState({recordmodel:true})
        }
      }).catch((error) => {
        alert(error)
      });
    }
    getLogData=(FromDate,ToDate,productKey)=>{
     // alert(FromDate)
      this.setState({rows:[]})
      fetch(`eadmin/v1/set/get_changesupportpin_log_data?FromDate=${FromDate}&ToDate=${ToDate}&productKey=${productKey}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          "x-access-token":getToken(),
        },
        }).then((response) => response.json())
        .then((responseJson) => {
        if(responseJson.status ){
          //alert(JSON.stringify(responseJson))
          this.setState({rows:responseJson.result})
        }else if(!responseJson.status){
          this.setState({recordmodel:true})
        }
      }).catch((error) => {
        alert(error)
      });
    }
    getLogData1=(FromDate1,ToDate1,productKey)=>{
      // alert(FromDate)
       this.setState({rows:[]})
       fetch(`eadmin/v1/set/get_surrender_log_data?FromDate=${FromDate1}&ToDate=${ToDate1}&productKey=${productKey}`, {
         method: 'GET',
         headers: {
           'Accept': 'application/json',
           'Content-Type': 'application/json',
           "x-access-token":getToken(),
         },
         }).then((response) => response.json())
         .then((responseJson) => {
         if(responseJson.status ){
           this.setState({rows1:responseJson.result})
         }else if(!responseJson.status){
           this.setState({recordmodel:true})
         }
       }).catch((error) => {
         alert(error)
       });
     }
    onrecordmodelclose=()=>{
    
      this.setState({recordmodel:false})
    }
    render(){
      return(
        <>
          {this.state.licenseData.map(row=>{
            return(
              <>
              <Box  elevation={3} sx={{backgroundColor: 'white',}}>
   
              <Grid container spacing={2}>
              <Grid item md={6}>
              <Grid container spacing={2}>
              <Grid item xs={1} sm={1} md={1}/>
              <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15}}>Product Name</p></Grid>
              <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
              <Grid item xs={4} sm={4} md={4}><p style={{fontWeight:'600',fontSize:15}}>{row.softwareidentificationname}</p></Grid>
              <Grid item xs={3} md={3} sm={3}/>
  
              <Grid item xs={1} sm={1} md={1}/>
              <Grid item xs={3} sm={3} md={3}><p> License key </p></Grid>
              <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
              <Grid item xs={5} sm={5} md={5}><p>{row.productkey}</p><br/></Grid>
              <Grid item xs={2} md={2} sm={2}/> 
  
              <Grid item xs={1} sm={1} md={1}/>
              <Grid item xs={3} sm={3} md={3}><p> No.of System </p></Grid>
              <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
              <Grid item xs={5} sm={5} md={5}><p>{row.noofsystem}</p><br/></Grid>
              <Grid item xs={2} md={2} sm={2}/> 
              </Grid>
              </Grid>
  
              <Grid item md={6}>
              <Grid container spacing={2}>
              <Grid item xs={1} sm={1} md={1}/>
              <Grid item xs={3} sm={3} md={3}><p style={{fontSize:15}}>No.of.MobileUser </p></Grid>
              <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
              <Grid item xs={4} sm={4} md={4}><p style={{fontWeight:'600',fontSize:15}}>{row.noofmobileuser}</p></Grid>
              <Grid item xs={3} md={3} sm={3}/>
  
              <Grid item xs={1} sm={1} md={1}/>
              <Grid item xs={3} sm={3} md={3}><p> MobileNo </p></Grid>
              <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
              <Grid item xs={5} sm={5} md={5}><p>{row.phonenumber} </p><br/></Grid>
              <Grid item xs={2} md={2} sm={2}/> 

              <Grid item xs={1} sm={1} md={1}/>
              <Grid item xs={3} sm={3} md={3}><p> support_pin </p></Grid>
              <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
              <Grid item xs={5} sm={5} md={5}><p>{row.supportpin} </p><br/></Grid>
              <Grid item xs={2} md={2} sm={2}/> 

              <Grid item xs={1} sm={1} md={1}/>
              <Grid item xs={3} sm={3} md={3}><p> license_surrender_date </p></Grid>
              <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
              <Grid item xs={5} sm={5} md={5}><p>{row.licensesurrender_datetime} </p><br/></Grid>
              <Grid item xs={2} md={2} sm={2}/> 

              <Grid item xs={1} sm={1} md={1}/>
              <Grid item xs={3} sm={3} md={3}><p> license_pinchange_date </p></Grid>
              <Grid item xs={1} sm={1} md={1}><p>:</p></Grid>
              <Grid item xs={5} sm={5} md={5}><p>{row.lastchangesupportpindate} </p><br/></Grid>
              <Grid item xs={2} md={2} sm={2}/> 
              </Grid>
              </Grid>
              </Grid>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon  onClick={()=>this.onDisplayModules(row.productkey)}/>}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                <Typography>Modules</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <label style={{color:'blue'}}>{this.state.modules}</label><br/>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                   <center> <h4>SUPPORTPIN_CHANGE_LOG</h4></center>
                  <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4}>
              <FormControl sx={{ m: 2, width: '95%' }}>
                  <label style={{paddingBottom:'10px'}}>From Date</label>
                  <DatePicker  value={this.state.fromDate}  maxDate={this.state.curDate}  dateFormat="DD-MM-YYYY" onChange={(value)=>this.setState({fromDate:value})}/>
              </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <FormControl sx={{ m: 2, width: '95%' }}>
                  <label style={{paddingBottom:'10px'}}>To Date</label>
                  <DatePicker  value={this.state.toDate}   maxDate={this.state.curDate} dateFormat="DD-MM-YYYY" onChange={(value)=>this.setState({toDate:value})}/>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <FormControl sx={{ m: 2, width: '95%' }}>
            <div className="button">
              <Button  variant="contained" style={{color:'white',width:'70%',marginTop:'15%'}} onClick={()=>this.getLogData(this.state.fromDate,this.state.toDate,row.productkey)}>VIEW</Button>
            </div>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={12}>
          <div style={{ width: '100%' }}>
              <div style={{ height: 600, width: '100%'}}>
                  <DataGrid
                  sx={{
                      boxShadow: 2,
                      fontWeight:'600',
                      '& .MuiDataGrid-cell:hover': {
                          color: '900',
                      },
                      }}
                      components={{ Toolbar: GridToolbar }}
                      rows={this.state.rows}
                      columns={this.state.columns}
                  />
              </div>
          </div>
          </Grid>
                  </Grid>
                  </Grid>
                  <Grid item xs={12} md={6}>
                  <center> <h4>SURRENDER_LOG</h4></center>
                  <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4}>
              <FormControl sx={{ m: 2, width: '95%' }}>
                  <label style={{paddingBottom:'10px'}}>From Date</label>
                  <DatePicker  value={this.state.fromDate1}  maxDate={this.state.curDate}  dateFormat="DD-MM-YYYY" onChange={(value)=>this.setState({fromDate1:value})}/>
              </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <FormControl sx={{ m: 2, width: '95%' }}>
                  <label style={{paddingBottom:'10px'}}>To Date</label>
                  <DatePicker  value={this.state.toDate1}   maxDate={this.state.curDate}  dateFormat="DD-MM-YYYY" onChange={(value)=>this.setState({toDate1:value})}/>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <FormControl sx={{ m: 2, width: '95%' }}>
            <div className="button">
              <Button  variant="contained" style={{color:'white',width:'70%',marginTop:'15%'}} onClick={()=>this.getLogData1(this.state.fromDate1,this.state.toDate1,row.productkey)}>VIEW</Button>
            </div>
            </FormControl>
          </Grid>
                  </Grid><br/>
                  <Grid item xs={12} md={12}>
          <div style={{ width: '100%' }}>
              <div style={{ height: 600, width: '100%'}}>
                  <DataGrid
                  sx={{
                      boxShadow: 2,
                      fontWeight:'600',
                      '& .MuiDataGrid-cell:hover': {
                          color: '900',
                      },
                      }}
                      components={{ Toolbar: GridToolbar }}
                      rows={this.state.rows1}
                      columns={this.state.columns1}
                  />
              </div>
          </div>
          </Grid>
                    </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
            </Box>   
            <br/><br/><br/><br/>
            <Grid container spacing={2}>
            <Grid item md={12}/>
          </Grid>
          </>
              
            )
            })
          }

            <ModalTransition>
                {this.state.recordmodel && (
                <Modal >
                  <ModalHeader>
                     Reports
                  </ModalHeader>
                  <ModalBody>
                       No Data Found
                  </ModalBody>
                  <ModalFooter>
                  <Button appearance="primary" onClick={this.onrecordmodelclose} autoFocus>OK</Button>
                  </ModalFooter>
                </Modal>
                )}
            </ModalTransition>
        </>  
      )
    }
}